const SCORE_STYLES = {
  low: "bg-gray-100 text-gray-600 border-gray-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  high: "bg-orange-100 text-orange-700 border-orange-200",
  critical: "bg-red-100 text-red-700 border-red-200",
};

const STATUS_STYLES = {
  open: "bg-blue-100 text-blue-700 border-blue-200",
  mitigating: "bg-amber-100 text-amber-700 border-amber-200",
  closed: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const scoreLevel = (n) =>
  n >= 20 ? "critical" : n >= 13 ? "high" : n >= 7 ? "medium" : "low";

// Hover definitions for the inherent / residual score badges.
const SCORE_DEFS = {
  I: "Inherent — severity before controls (likelihood × impact, 1–25)",
  Inherent: "Inherent — severity before controls (likelihood × impact, 1–25)",
  R: "Residual — severity after controls; ≥13 is high",
  Residual: "Residual — severity after controls; ≥13 is high",
};

export const ScoreBadge = ({ score, label }) => {
  const level = scoreLevel(score);
  const def = SCORE_DEFS[label];
  return (
    <span
      data-testid={`score-badge-${level}`}
      data-level={level}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${SCORE_STYLES[level]}`}
      title={def ? `${def} · ${score}/25` : `${label || "Score"}: ${score}/25`}
    >
      {label && <span className="opacity-60">{label}</span>}
      {score}
    </span>
  );
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize ${
      STATUS_STYLES[status] || STATUS_STYLES.open
    }`}
  >
    {status}
  </span>
);
